/* eslint-disable max-len */
/* eslint-disable no-useless-escape */
export default function validate(typeToValidate, valueToValidate) {
  console.log("rshmi ",typeToValidate)
  switch (typeToValidate) {
  case 'email':
    return (/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)
      .test(valueToValidate);
  case 'password':
    return valueToValidate.length > 4;
  case 'otp':
    return (/^$|\s+/).test(valueToValidate);
  case 'employeeId':
    return (/^(?!\s*$).+/).test(valueToValidate);
  case 'vendorCode':
    return (/^(?!\s*$).+/).test(valueToValidate);
  case 'customerId':
    return (/^(?!\s*$).+/).test(valueToValidate);
  case 'phone':
    return (/^\d{10}$/).test(valueToValidate);
  case 'phoneNo':
    return (/^\d{10}$/).test(valueToValidate);
  case 'phoneNumber':
    return (/^\d{10}$|^$/).test(valueToValidate);
  case  'contactNumber':
    return (/^\d{10}$|^$/).test(valueToValidate);
  case 'fullName':
    return (/^[a-zA-Z][a-zA-Z.\s]+$/).test(valueToValidate);
  case 'customerName':
    return (/^[a-zA-Z][a-zA-Z.\s]+$/).test(valueToValidate); 
  case 'vendorName':
    return (/^[a-zA-Z][a-zA-Z.\s]+$/).test(valueToValidate); 
  
  case 'address':
    return (/^(?!\s*$).+/).test(valueToValidate);
  case 'shippingAddress':
    return (/^(?!\s*$).+/).test(valueToValidate);
  case 'customerLogo':
    return (/^(?!\s*$).+/).test(valueToValidate);
  case 'customerTheme':
    return (/^(?!\s*$).+/).test(valueToValidate);
  case 'companyName':
    return (/^[a-zA-Z][a-zA-Z.\s]+$/).test(valueToValidate);
  case 'category':
    return (/^[a-zA-Z][a-zA-Z.\s]+$/).test(valueToValidate);
  case 'contactPersonName':
    return (/^[a-zA-Z][a-zA-Z.\s]+$/).test(valueToValidate);
  case 'companyCode':
    return (/^(?!\s*$).+/).test(valueToValidate);
  case 'emailId':
    return (/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)
      .test(valueToValidate);
  case 'contactPerson':
    return (/^[a-zA-Z][a-zA-Z.\s]+$/).test(valueToValidate);
  case 'categoryName':
    return (/^(?!\s*$).+/).test(valueToValidate);
  case 'categoryDescription':
    return (/^(?!\s*$).+/).test(valueToValidate);
  case 'stateName':
    return (/^[a-zA-Z][a-zA-Z.\s]+$/).test(valueToValidate);
  case 'branchName':
    return (/^[a-zA-Z][a-zA-Z.\s]+$/).test(valueToValidate);
  case 'facilityName':
    return (/^[a-zA-Z0-9\s,'-]*$/).test(valueToValidate);
  case 'labDepName':
    return (/^[a-zA-Z][a-zA-Z.\s]+$/).test(valueToValidate);
  case 'labDepMap':
    return (/^(?!\s*$).+/).test(valueToValidate);
  case 'number':
    return (/^\d+$/).test(valueToValidate);
  case 'Decimalnumber':
    return (/^(\d{1,9}|\d{1,9}\.\d{1,9})$/).test(valueToValidate);
  case 'NegativeDecimalnumber':
    return (/^-?[0-9]\d*(\.\d+)?$/).test(valueToValidate);
  case 'GSTNumber':
    return (/^[a-zA-Z\-0-9]{0,12}$/).test(valueToValidate);
  default:
    return false;
  }
}
